import { ValidatorPosition } from '../../position/validator-position';
export const config = () => {
    const result = {
        value: 'custom',
        position: [
            ValidatorPosition.filter,
            ValidatorPosition.form,
            ValidatorPosition.formDialog,
            ValidatorPosition.cnArrayTable,
            ValidatorPosition.cnArraySubAreaCard,
        ],
    };
    return result;
};
